module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_9016.8504e649.png";